import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  AddFormButton,
  FilterButton,
} from "../TableElements";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import ImportColMappingComponent from "./ImportColMappingComponent";
import Error from "@/shared/components/form/Error";
import ImportFileUploader from "./ImportFileUploader";
import Select from "react-select";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import {
  ALBUM_BUCKET_NAME,
  BUCKET_REGION,
  IDENTITY_POOL_ID,
} from "../../constants";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { useSelector } from "react-redux";
import { Steps } from "primereact/steps";
import { scrollbarStyles } from "../../../utils/palette";
import styled from "styled-components";
import { useEffect } from "react";
import { getVehicles, post, postApi } from "../../../api/getUser";
import { TableSpinner } from "../table/components/ReactTableConstructor";
import ImportCompleteComponent from "./ImportCompleteComponent";
import { getScreenName } from "../../helpers";
import { useAuth } from "../../../contexts/AuthContext";
import ErrorDetailsTable from "./ErrorDetailsTable";
import { auth, firebaseConfig } from "../../../api/firebase";
import {
  createUserWithEmailAndPassword,
  getAuth,
  inMemoryPersistence,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getImportData } from "./importData";
import useLazyWebSocket from "../../custom-hooks/useLazyWebsocket";
import { formStyles } from "../../constants/styles";
import { useRef } from "react";
import {
  fetchServicesTasks,
  fetchServiceTaskCategories,
} from "../../../features/servicesTasks/servicesTasksSlice";
import { fetchExpenseTasks } from "../../../features/expenseTasks/expenseTasksSlice";
import { useDispatch } from "react-redux";
import SubscribePopup from "../SubscribePopup";
import { fetchInspectionTasks } from "../../../features/inspectionTasks/inspectionTasksSlice";
import { Desc } from "../form/FormElements";
import { updateVehiclesList } from "../../../features/vehicles/vehiclesSlice";

const ImportComponent = ({ showPopup, setShowPopup, screenName }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;

  const { distance } = useSelector((state) => state.units);
  const { userId } = useSelector((state) => state.user);

  const allUsers = useSelector((state) => state.users.list);
  const loggedInUser = allUsers.find((u) => u.user_id === userId);

  const [screen, setScreen] = useState(screenName ? screenName : "");
  const [selectModule, setSelectModule] = useState(null);

  const { orgId, roleId } = useSelector((state) => state.user);

  const [importFile, setImportFile] = useState(null);
  const [mode, setMode] = useState(0);

  const [errMsg, setErrMsg] = useState("");

  const [selectValues, setSelectValues] = useState({});
  // const [dateFormat, setDateFormat] = useState(null);

  const [importLoading, setImportLoading] = useState(false);

  const [issuesArr, setIssuesArr] = useState([]);

  const { setReload, tag } = useAuth();

  const [showErrDetails, setShowErrDetails] = useState(false);

  const [noOfRowsInserted, setNoOfRowsInserted] = useState(0);

  const didUnmount = useRef(false);
  const isIntentionalClosure = useRef(false);
  const pendingMessageRef = useRef(null);

  const [scrollableBodyHeight, setScrollableBodyHeight] = useState(400);

  const {
    options,
    otherMandatoryFields,
    queryString,
    screenHeading,
    sampleFileName,
  } = getImportData(screen);

  //State to show subscribe popup
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [subscribeMsg, setSubscribeMsg] = useState(t("subscribe_msg"));

  //State to store mesaage when no of vehicles to import > vehicle subscription count
  const [vehicleLimitErrMsg, setVehicleLimitErrMsg] = useState("");

  //This is used to disable import btn if veh limit err occurs
  const [disableImport, setDisableImport] = useState(false);

  // const webSocketApi =
  //   process.env.REACT_APP_ENV === "test"
  //     ? "wss://3dg5rjnwel.execute-api.ap-south-1.amazonaws.com/test/"
  //     : "wss://tk15odkbyb.execute-api.us-east-1.amazonaws.com/prod/";
  const webSocketApi =
    process.env.REACT_APP_ENV === "test"
      ? "wss://ufr3i1pr0m.execute-api.ap-south-1.amazonaws.com/test/"
      : "wss://m4of0dsoyh.execute-api.us-east-1.amazonaws.com/prod/";

  const {
    connect,
    disconnect,
    sendMessage,
    lastMessage,
    getWebSocket,
    readyState,
    isConnected,
    connectionError,
  } = useLazyWebSocket(webSocketApi, {
    inactivityTimeout: 300000,
    onOpen: () => {
      console.log("🔌 Import WebSocket opened, ready to send messages");
      // Send any pending message
      if (pendingMessageRef.current) {
        console.log("📤 Sending pending import message");
        sendMessage(pendingMessageRef.current);
        pendingMessageRef.current = null;
      }
    },
    onClose: () => {
      console.log("❌ Import WebSocket closed at " + new Date());
      if (importLoading && !isIntentionalClosure.current) {
        setImportLoading(false);
        setErrMsg(t("import_upload_failed_err"));
        setMode(2);
      }
    },
    onMessage: (event) => {
      try {
        console.log("📨 Import WebSocket message received", event);
        // if (!event.data) {
        //   disconnect();
        //   setErrMsg(t("listing_err_msg"));
        //   setImportLoading(false);
        //   setMode(2);
        // }
        handleOnMessage(event.data);
      } catch (error) {
        console.error("❌ Error parsing WebSocket message:", error);
        disconnect();
        setErrMsg(t("listing_err_msg"));
        setImportLoading(false);
        setMode(2);
      }
    },
  });

  let moduleOptions = [
    {
      label: t("fillups"),
      value: "fillups",
    },
    {
      label: t("se_mileage"),
      value: "dailymileage",
    },
    {
      label: t("trips"),
      value: "trips",
    },
    {
      label: t("services"),
      value: "service",
    },
    {
      label: t("expenses"),
      value: "expense",
    },
    {
      label: t("service_tasks"),
      value: "servicetasks",
    },
    {
      label: t("expense_tasks"),
      value: "expensetasks",
    },
    {
      label: t("inspection_tasks"),
      value: "inspectiontasks",
    },
    {
      label: t("maintenance_reminders"),
      value: "maintenancereminders",
    },
    {
      label: t("renewals"),
      value: "renewals",
    },
    {
      label: t("inspection_forms"),
      value: "inspectionforms",
    },
    {
      label: t("vehicles"),
      value: "vehicles",
    },
    {
      label: t("users"),
      value: "users",
    },
    {
      label: t("groups"),
      value: "groups",
    },
    {
      label: t("vehicle_assignment"),
      value: "vehicleassignment",
    },
    {
      label: t("parts"),
      value: "parts",
    },
    {
      label: t("batches"),
      value: "partBatches",
    },
    {
      label: t("small_equipment"),
      value: "equipment",
    },
  ];

  //Managers cannot import groups
  if (roleId === 2) {
    moduleOptions = moduleOptions.filter((m) => m.value !== "groups");
  }

  useEffect(() => {
    return () => {
      didUnmount.current = true;
    };
  }, []);

  //Set scrollableBodyHeight
  useEffect(() => {
    if (screenName) {
      if (errMsg) {
        setScrollableBodyHeight(window.innerHeight - 340);
      } else {
        setScrollableBodyHeight(window.innerHeight - 330);
      }
    } else {
      if (errMsg) {
        setScrollableBodyHeight(window.innerHeight - 360);
      } else {
        setScrollableBodyHeight(window.innerHeight - 340);
      }
    }
  }, [errMsg, screenName]);

  // Handle WebSocket connection errors
  useEffect(() => {
    if (connectionError) {
      console.error("🚨 Import WebSocket connection error:", connectionError);
      setErrMsg(t("websocket_connection_closed_err_msg"));
      setImportLoading(false);
    }
  }, [connectionError, t]);

  function handleOnMessage(data) {
    if (data) {
      const parsedRes = JSON.parse(data);
      if (
        parsedRes?.message &&
        parsedRes.message === "Endpoint request timed out"
      ) {
        return;
      }
      const res = parsedRes[0]?.value;
      console.log("res", res);

      if (!res || !res?.success) {
        setErrMsg(t("listing_err_msg"));
        setImportLoading(false);
        setMode(2);
      }

      if (res?.success) {
        handleIssueResponse(res);
      }
      console.log("✅ Import completed, disconnecting WebSocket");
      didUnmount.current = true;
      isIntentionalClosure.current = true;
      disconnect();
      //console.log(JSON.parse(data));
    }
  }

  const modalHeading = t("import_screen_into_sf", {
    screenName: screenName ? screenHeading : t("data"),
  });

  const stepItems = [
    {
      label: t("upload_file"),
    },
    {
      label: t("map_cols"),
    },
    {
      label: t("import_file"),
    },
  ];

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleBack = () => {
    if (screenName === "vehicles") {
      setDisableImport(false);
      setVehicleLimitErrMsg("");
    }
    setSelectValues({});
    // setDateFormat({});
    setErrMsg("");
    setImportFile(null);
    setMode(0);
  };

  const handleOkay = () => {
    setShowPopup(false);
  };

  const createFirebaseUser = async (email, password) => {
    // Clean email: trim whitespace, remove surrounding quotes, convert to lowercase
    const cleanEmail = email
      ?.toString()
      .trim()
      .replace(/^["']|["']$/g, "")
      .toLocaleLowerCase();

    // Clean password: trim whitespace, remove surrounding quotes
    const cleanPassword = password
      ?.toString()
      .trim()
      .replace(/^["']|["']$/g, "");

    const tempApp = initializeApp(firebaseConfig, cleanEmail);
    const tempAuth = getAuth(tempApp);
    tempAuth.setPersistence(inMemoryPersistence);

    const res = await createUserWithEmailAndPassword(
      tempAuth,
      cleanEmail,
      cleanPassword,
    );
    console.log("firebase res", res);
    return res.user;
    //const user = res?.user;
  };

  //get the index of whatever's available - name(Vehicle Name), license_no, vin_no
  const getVehicleDataIndex = () => {
    let vehIndex = 0;
    let selectValuesArr = Object.values(selectValues).map((o) => o.value);

    if (selectValuesArr.includes("name")) {
      const vehNameEntry = Object.entries(selectValues).find(
        (arr) => arr[1].value === "name",
      );

      vehIndex = +vehNameEntry[0];
      //console.log("vehIndex", vehIndex);
      return vehIndex;
    }

    if (selectValuesArr.includes("license_no")) {
      const licenseEntry = Object.entries(selectValues).find(
        (arr) => arr[1].value === "license_no",
      );

      vehIndex = +licenseEntry[0];
      return vehIndex;
    }

    if (selectValuesArr.includes("vin_no")) {
      const vinEntry = Object.entries(selectValues).find(
        (arr) => arr[1].value === "vin_no",
      );

      vehIndex = +vinEntry[0];
      return vehIndex;
    }

    return vehIndex;
  };

  //To convert from "1,2,3" to [1, 2, 3]
  const convertToNumberedIndex = (str) =>
    str
      ? str
          .split(",")
          .filter((val) => val)
          .map((val) => +val)
      : [];

  const handleIssueResponse = async (res) => {
    console.log("res", res);
    const issueRowStringArr = convertToNumberedIndex(
      res.insert_issue_row_string,
    );
    //console.log("issueRowStringArr", issueRowStringArr);
    //if (issueRowStringArr.length > 0) {
    let issuesArrData = [];
    if (screen === "vehicles" || screen === "equipment") {
      //Update vehicles list in redux
      const updatedVehiclesList = await getVehicles();
      dispatch(updateVehiclesList(updatedVehiclesList));

      const {
        //insert_issue_row_string,
        vehicle_name_empty_rows,
        make_empty_rows,
        model_empty_rows,
        veh_name_present_rows,
        fuel_type_warning_rows,
        primary_meter_warning_rows,
        group_not_present_rows,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const makeEmptyRows = convertToNumberedIndex(make_empty_rows);
      const modelEmptyRows = convertToNumberedIndex(model_empty_rows);
      const vehNamePresentRows = convertToNumberedIndex(veh_name_present_rows);
      const groupNotPresentRows = convertToNumberedIndex(
        group_not_present_rows,
      );
      //const vinPresentRows = convertToNumberedIndex(vin_present_rows);
      //const licensePresentRows = convertToNumberedIndex(license_present_rows);
      const fuelTypeWarningRows = convertToNumberedIndex(
        fuel_type_warning_rows,
      );
      const primaryMeterWarningRows = convertToNumberedIndex(
        primary_meter_warning_rows,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...makeEmptyRows,
        ...modelEmptyRows,
        ...vehNamePresentRows,
        ...groupNotPresentRows,
        //...vinPresentRows,
        //...licensePresentRows,
        ...fuelTypeWarningRows,
        ...primaryMeterWarningRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      console.log(allIssuesSortedIndicesArr);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message:
              screen === "vehicles"
                ? t("veh_name_empty_err_msg")
                : t("equipment_name_empty_err_msg"),
          };
        } else if (makeEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message:
              screen === "vehicles"
                ? t("veh_make_empty_err_msg")
                : t("equipment_make_empty_err_msg"),
          };
        } else if (modelEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message:
              screen === "vehicles"
                ? t("veh_model_empty_err_msg")
                : t("equipment_model_empty_err_msg"),
          };
        } else if (vehNamePresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message:
              screen === "vehicles"
                ? t("veh_name_present_err_msg")
                : t("equipment_name_present_err_msg"),
          };
        } else if (groupNotPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("group_not_present_err_msg"),
          };
        } else if (fuelTypeWarningRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("fuel_type_warn_msg"),
          };
        } else if (primaryMeterWarningRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("primary_meter_warn_msg", {
              defaultPrimaryMeter: distance,
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "servicetasks") {
      dispatch(fetchServiceTaskCategories({ force: true }));

      const {
        //insert_issue_row_string,
        //vehicle_name_empty_rows,
        //veh_name_present_rows,
        //vin_present_rows,
        //license_present_rows,
        veh_not_found_string,
        vehicle_name_empty_rows,
        service_task_name_empty_rows,
        record_present_rows,
      } = res;

      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const serviceTaskNameEmptyRows = convertToNumberedIndex(
        service_task_name_empty_rows,
      );
      const recordPresentRows = convertToNumberedIndex(record_present_rows);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNotFoundRows,
        ...vehNameEmptyRows,
        ...serviceTaskNameEmptyRows,
        ...recordPresentRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      let vehDataIndex = getVehicleDataIndex();
      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            // message: `${
            //   importFile?.rows[rowIndex][vehDataIndex]
            //     ? importFile?.rows[rowIndex][vehDataIndex]
            //     : t("vehicle")
            // } ${t("not_found")}`,
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("veh_empty_err_msg"),
          };
        } else if (serviceTaskNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName: t("service_task_name"),
            }),
          };
        } else if (recordPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("service_task_name"),
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "expensetasks") {
      const {
        veh_not_found_string,
        vehicle_name_empty_rows,
        expense_task_name_empty_rows,
        record_present_rows,
      } = res;

      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const expenseTaskNameEmptyRows = convertToNumberedIndex(
        expense_task_name_empty_rows,
      );
      const recordPresentRows = convertToNumberedIndex(record_present_rows);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNotFoundRows,
        ...expenseTaskNameEmptyRows,
        ...recordPresentRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      let vehDataIndex = getVehicleDataIndex();
      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (recordPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("expense_task_name"),
            }),
          };
        } else if (expenseTaskNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName: t("expense_task_name"),
            }),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("veh_empty_err_msg"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "inspectiontasks") {
      const {
        veh_not_found_string,
        inspection_task_name_empty_rows,
        record_present_rows,
      } = res;

      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const inspectionTaskNameEmptyRows = convertToNumberedIndex(
        inspection_task_name_empty_rows,
      );
      const recordPresentRows = convertToNumberedIndex(record_present_rows);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNotFoundRows,
        ...inspectionTaskNameEmptyRows,
        ...recordPresentRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      let vehDataIndex = getVehicleDataIndex();
      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (inspectionTaskNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName: t("inspection_task_name"),
            }),
          };
        } else if (recordPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("inspection_task_name"),
            }),
          };
        } else if (
          vehNotFoundRows.includes(rowIndex) &&
          !issueRowStringArr.includes(rowIndex)
        ) {
          return {
            rowIndex,
            type: "warning",
            // message: `${
            //   importFile?.rows[rowIndex][vehDataIndex]
            //     ? importFile?.rows[rowIndex][vehDataIndex]
            //     : t("vehicle")
            // } ${t("not_found")}`,
            message: t("veh_does_not_exist_err_msg"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "users") {
      const {
        //insert_issue_row_string,
        user_name_empty_rows,
        user_email_empty_rows,
        email_present_rows,
        email_present_in_other_org_rows,
        user_role_type_warning_rows,
        invalid_user_email_rows,
        manager_not_exist_warning_rows,
      } = res;

      const userNameEmptyRows = convertToNumberedIndex(user_name_empty_rows);
      const userEmailEmptyRows = convertToNumberedIndex(user_email_empty_rows);
      const emailPresentRows = convertToNumberedIndex(email_present_rows);
      const emailPresentInOtherOrgRows = convertToNumberedIndex(
        email_present_in_other_org_rows,
      );
      //const vinPresentRows = convertToNumberedIndex(vin_present_rows);
      //const licensePresentRows = convertToNumberedIndex(license_present_rows);
      const userRoleTypeWarningRows = convertToNumberedIndex(
        user_role_type_warning_rows,
      );
      const noManagerWarningRows = convertToNumberedIndex(
        manager_not_exist_warning_rows,
      );

      const invalidUserEmailRows = convertToNumberedIndex(
        invalid_user_email_rows,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...userNameEmptyRows,
        ...userEmailEmptyRows,
        ...emailPresentRows,
        ...emailPresentInOtherOrgRows,
        ...invalidUserEmailRows,
        ...userRoleTypeWarningRows,
        ...noManagerWarningRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      console.log(allIssuesSortedIndicesArr);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (userNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", { fieldName: t("name") }),
          };
        } else if (userEmailEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", { fieldName: t("email") }),
          };
        } else if (emailPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("email_present_err_msg"),
          };
        } else if (emailPresentInOtherOrgRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("email_part_of_other_org_err_msg"),
          };
        } else if (invalidUserEmailRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("invalid_email_format_err_msg"),
          };
        } else if (userRoleTypeWarningRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("invalid_role_type_warn_msg"),
          };
        } else if (noManagerWarningRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("entity_does_not_exist_warn_msg", {
              entity: t("manager"),
              entityDefaultValue: loggedInUser?.label,
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });

      setIssuesArr(issuesArrData);

      //Add users to firebase - start
      //console.log(importFile?.rows);
      let usersToFirebase = importFile.rows.filter(
        (row, i) => !issueRowStringArr.includes(i + 1),
      );

      let emailIndex = 1;
      const emailEntry = Object.entries(selectValues).find(
        (arr) => arr[1].value === "email",
      );
      emailIndex = +emailEntry[0];

      let passwordIndex = 1;
      const passwordEntry = Object.entries(selectValues).find(
        (arr) => arr[1].value === "password",
      );
      passwordIndex = +passwordEntry[0];

      console.log("usersToFirebase", usersToFirebase);

      if (usersToFirebase.length === 0) {
        setImportLoading(false);
        setMode(2);
        setReload(getScreenName(pathname));
      } else {
        for (let user of usersToFirebase) {
          console.log(user[emailIndex], user[passwordIndex]);
          try {
            await createFirebaseUser(user[emailIndex], user[passwordIndex]);
          } catch (error) {
            // Ignore errors (e.g., user already exists) and continue with next user
            console.log("Error adding user to Firebase:", error);
          }
        }
        // After processing all users (regardless of success/failure), show success
        setImportLoading(false);
        setMode(2);
        setReload(getScreenName(pathname));
      }
      //Add users to firebase - end
    }

    if (screen === "fillups") {
      const {
        //insert_issue_row_string,
        vehicle_name_empty_rows,
        veh_not_found_string,
        date_not_found_string,
        qty_not_found_string,
        odo_not_found_string,
        filled_by_exist_warning_rows_string,
        transaction_type_not_found_warning_string,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const dateNotFoundRows = convertToNumberedIndex(date_not_found_string);
      const qtyNotFoundRows = convertToNumberedIndex(qty_not_found_string);
      const odoNotFoundRows = convertToNumberedIndex(odo_not_found_string);

      const filledByExistsRows = convertToNumberedIndex(
        filled_by_exist_warning_rows_string,
      );
      const transactionTypeNotFoundRows = convertToNumberedIndex(
        transaction_type_not_found_warning_string,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...vehNotFoundRows,
        ...dateNotFoundRows,
        ...qtyNotFoundRows,
        ...odoNotFoundRows,
        ...filledByExistsRows,
        ...transactionTypeNotFoundRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_empty_err_msg"),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (dateNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", { fieldName: t("date_tv") }),
          };
        } else if (qtyNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", { fieldName: t("fuel_qty") }),
          };
        } else if (odoNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", { fieldName: t("odo_value") }),
          };
        } else if (filledByExistsRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("filled_by_user_does_not_exist_warn_msg", {
              entityDefaultValue: loggedInUser?.label,
            }),
          };
        } else if (transactionTypeNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("transaction_type_warn_msg"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "dailymileage") {
      const {
        veh_not_found_string,
        user_not_found_string,
        vehicle_name_empty_rows,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const userNotFoundRows = convertToNumberedIndex(user_not_found_string);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...vehNotFoundRows,
        ...userNotFoundRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_empty_err_msg"),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (userNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("entity_does_not_exist_warn_msg", {
              entity: t("entered_by"),
              entityDefaultValue: loggedInUser?.label,
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    //Trips
    if (screen === "trips") {
      const {
        vehicle_name_empty_rows,
        veh_not_found_string,
        dep_date_not_found_string,
        arr_date_not_found,
        arr_odo_not_found_string,
        dep_odo_not_found_string,
        dep_odo_greaterthan_arr_odo_rows_string,
        dep_date_greaterthan_arr_date_rows_string,
        trip_by_exist_warning_rows_string,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const depDateNotFoundRows = convertToNumberedIndex(
        dep_date_not_found_string,
      );
      const arrDateNotFoundRows = convertToNumberedIndex(arr_date_not_found);
      const depOdoNotFoundRows = convertToNumberedIndex(
        dep_odo_not_found_string,
      );
      const arrOdoNotFoundRows = convertToNumberedIndex(
        arr_odo_not_found_string,
      );
      const depOdoGreaterThanArrOdoRows = convertToNumberedIndex(
        dep_odo_greaterthan_arr_odo_rows_string,
      );
      const depDateGreaterThanArrDateRows = convertToNumberedIndex(
        dep_date_greaterthan_arr_date_rows_string,
      );
      const tripByExistsRows = convertToNumberedIndex(
        trip_by_exist_warning_rows_string,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...vehNotFoundRows,
        ...depDateNotFoundRows,
        ...arrDateNotFoundRows,
        ...depOdoNotFoundRows,
        ...arrOdoNotFoundRows,
        ...depOdoGreaterThanArrOdoRows,
        ...depDateGreaterThanArrDateRows,
        ...tripByExistsRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_empty_err_msg"),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (depDateNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_not_found_err_msg", {
              entity: t("dep_date_and_time"),
            }),
          };
        } else if (arrDateNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_not_found_err_msg", {
              entity: t("arr_date_and_time"),
            }),
          };
        } else if (depOdoNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_not_found_err_msg", {
              entity: t("starting_odo"),
            }),
          };
        } else if (arrOdoNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_not_found_err_msg", {
              entity: t("ending_odo"),
            }),
          };
        } else if (depOdoGreaterThanArrOdoRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("dep_odo_greater_than_arr_odo_err_msg"),
          };
        } else if (depDateGreaterThanArrDateRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("dep_date_greater_than_arr_date_err_msg"),
          };
        } else if (tripByExistsRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("entity_does_not_exist_warn_msg", {
              entity: t("trip_by"),
              entityDefaultValue: loggedInUser?.label,
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "maintenancereminders" || screen === "renewals") {
      if (screen === "maintenancereminders") {
        //Fetch all service tasks
        (async () => {
          const apiData = {
            //email: "testgroup@12.in",
            querystring: "getallservicetask",
            service_veh_id: "All",
          };
          dispatch(fetchServicesTasks(apiData));
          // }
        })();
      } else {
        //Fetch all expense tasks
        (async () => {
          const apiData = {
            querystring: "getallexpensetask",
            expense_veh_id: "All",
          };
          dispatch(fetchExpenseTasks(apiData));
        })();
      }

      const {
        //insert_issue_row_string,
        vehicle_name_empty_rows,
        veh_not_found_string,
        service_task_name_empty_rows,
        due_odo_due_days_empty_rows,
        email_recipient_not_found_warning_rows,
        negative_due_on_date_rows,
        negative_due_on_odo_rows,
        record_present_rows,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const serviceTaskNameEmptyRows = convertToNumberedIndex(
        service_task_name_empty_rows,
      );
      const dueEmptyRows = convertToNumberedIndex(due_odo_due_days_empty_rows);
      const emailNotFoundRows = convertToNumberedIndex(
        email_recipient_not_found_warning_rows,
      );
      const recordPresentRows = convertToNumberedIndex(record_present_rows);
      const negativeDueOnDateRows = convertToNumberedIndex(
        negative_due_on_date_rows,
      );
      const negativeDueOnOdoRows = convertToNumberedIndex(
        negative_due_on_odo_rows,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...vehNotFoundRows,
        ...serviceTaskNameEmptyRows,
        ...dueEmptyRows,
        ...emailNotFoundRows,
        ...recordPresentRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_empty_err_msg"),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (serviceTaskNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName:
                screen === "maintenancereminders"
                  ? t("service_task_name")
                  : t("expense_task_name"),
            }),
          };
        } else if (dueEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("interval_cant_be_empty_err_msg"),
          };
        } else if (recordPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity:
                screen === "maintenancereminders"
                  ? t("maint_reminder")
                  : t("renewal"),
            }),
          };
        } else if (negativeDueOnDateRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message:
              screen === "maintenancereminders"
                ? t("negative_due_on_date_err_msg_service")
                : t("negative_due_on_date_err_msg_expense"),
          };
        } else if (negativeDueOnOdoRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message:
              screen === "maintenancereminders"
                ? t("negative_due_on_odo_err_msg_service")
                : t("negative_due_on_odo_err_msg_expense"),
          };
        } else if (
          emailNotFoundRows.includes(rowIndex) &&
          !issueRowStringArr.includes(rowIndex)
        ) {
          return {
            rowIndex,
            type: "warning",
            message: t("entity_does_not_exist_warn_msg", {
              entity: t("email"),
              entityDefaultValue: loggedInUser?.label,
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "service" || screen === "expense") {
      if (screen === "service") {
        //Fetch all service tasks
        (async () => {
          const apiData = {
            //email: "testgroup@12.in",
            querystring: "getallservicetask",
            service_veh_id: "All",
          };
          dispatch(fetchServicesTasks(apiData));
          // }
        })();
      } else {
        //Fetch all expense tasks
        (async () => {
          const apiData = {
            querystring: "getallexpensetask",
            expense_veh_id: "All",
          };
          dispatch(fetchExpenseTasks(apiData));
        })();
      }
      const {
        //insert_issue_row_string,
        vehicle_name_empty_rows,
        veh_not_found_string,
        service_task_name_empty_rows,
        odo_not_found_string,
        date_not_found_string,
        serviced_by_exist_warning_rows_string,
        transaction_type_not_found_warning_string,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const serviceTaskNameEmptyRows = convertToNumberedIndex(
        service_task_name_empty_rows,
      );

      const odoNotFoundRows = convertToNumberedIndex(odo_not_found_string);
      const dateNotFoundRows = convertToNumberedIndex(date_not_found_string);

      const servicedByNotFoundRows = convertToNumberedIndex(
        serviced_by_exist_warning_rows_string,
      );

      const transactionTypeNotFoundRows = convertToNumberedIndex(
        transaction_type_not_found_warning_string,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...vehNotFoundRows,
        ...serviceTaskNameEmptyRows,
        ...dateNotFoundRows,
        ...odoNotFoundRows,
        ...servicedByNotFoundRows,
        ...transactionTypeNotFoundRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_empty_err_msg"),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (serviceTaskNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName:
                screen === "service"
                  ? t("service_task_name")
                  : t("expense_task_name"),
            }),
          };
        } else if (dateNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName:
                screen === "service" ? t("service_date") : t("date_tv"),
            }),
          };
        } else if (odoNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", { fieldName: t("odo_value") }),
          };
        } else if (
          servicedByNotFoundRows.includes(rowIndex) &&
          !issueRowStringArr.includes(rowIndex)
        ) {
          return {
            rowIndex,
            type: "warning",
            message: t("entity_does_not_exist_warn_msg", {
              entity: t("email"),
              entityDefaultValue: loggedInUser?.label,
            }),
          };
        } else if (
          transactionTypeNotFoundRows.includes(rowIndex) &&
          !issueRowStringArr.includes(rowIndex)
        ) {
          return {
            rowIndex,
            type: "warning",
            message: t("transaction_type_warn_msg"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    //Inspection Forms
    if (screen === "inspectionforms") {
      //Fetch all insp tasks
      (async () => {
        const apiData = {
          querystring: "get_all_inspection_tasks",
        };
        dispatch(fetchInspectionTasks(apiData));
      })();
      const {
        inspection_task_name_empty_rows,
        inspection_form_name_empty_rows,
        record_present_rows,
      } = res;

      const inspectionTaskNameEmptyRows = convertToNumberedIndex(
        inspection_task_name_empty_rows,
      );
      const inspectionFormNameEmptyRows = convertToNumberedIndex(
        inspection_form_name_empty_rows,
      );

      const recordPresentRows = convertToNumberedIndex(record_present_rows);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...inspectionTaskNameEmptyRows,
        ...inspectionFormNameEmptyRows,
        ...recordPresentRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      let vehDataIndex = getVehicleDataIndex();
      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (inspectionTaskNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName: t("inspection_task"),
            }),
          };
        } else if (inspectionFormNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName: t("form_name"),
            }),
          };
        } else if (recordPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("form_name"),
            }),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    //Groups
    if (screen === "groups") {
      const {
        group_name_present_rows,
        group_name_empty_rows,
        group_level_reached_rows,
        parent_not_found_rows,
      } = res;

      const groupNamePresentRows = convertToNumberedIndex(
        group_name_present_rows,
      );
      const groupNameEmptyRows = convertToNumberedIndex(group_name_empty_rows);
      const parentNotFoundRows = convertToNumberedIndex(parent_not_found_rows);
      const groupLevelReachedRows = convertToNumberedIndex(
        group_level_reached_rows,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...groupNamePresentRows,
        ...groupNameEmptyRows,
        ...parentNotFoundRows,
        ...groupLevelReachedRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (groupNamePresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("group_name"),
            }),
          };
        } else if (groupNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("field_empty_err_msg", {
              fieldName: t("group_name"),
            }),
          };
        } else if (groupLevelReachedRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("group_level_err_msg"),
          };
        } else if (parentNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("parent_group_not_found_err_msg"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    //Vehicle Assignment
    if (screen === "vehicleassignment") {
      const {
        vehicle_name_empty_rows,
        veh_not_found_string,
        user_name_email_empty_rows_string,
        user_name_email_not_found_rows_string,
      } = res;

      const vehNameEmptyRows = convertToNumberedIndex(vehicle_name_empty_rows);
      const vehNotFoundRows = convertToNumberedIndex(veh_not_found_string);
      const userEmailEmptyRows = convertToNumberedIndex(
        user_name_email_empty_rows_string,
      );
      const userEmailNotFoundRows = convertToNumberedIndex(
        user_name_email_not_found_rows_string,
      );

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...vehNameEmptyRows,
        ...vehNotFoundRows,
        ...userEmailEmptyRows,
        ...userEmailNotFoundRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (vehNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_empty_err_msg"),
          };
        } else if (vehNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("veh_does_not_exist_err_msg"),
          };
        } else if (userEmailEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("user_empty_err_msg"),
          };
        } else if (userEmailNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("user_does_not_exist_err_msg"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    //Vehicle Assignment
    if (screen === "parts") {
      const {
        record_present_rows,
        parts_name_empty_rows,
        location_is_empty_rows,
        available_quantity_is_empty_rows,
        part_number_present_rows,
        barcode_present_rows,
      } = res;

      const recordPresentRows = convertToNumberedIndex(record_present_rows);
      const partNameEmptyRows = convertToNumberedIndex(parts_name_empty_rows);
      const locationEmptyRows = convertToNumberedIndex(location_is_empty_rows);
      const availableQtyEmptyRows = convertToNumberedIndex(
        available_quantity_is_empty_rows,
      );
      const partNoPresentRows = convertToNumberedIndex(
        part_number_present_rows,
      );
      const barcodePresentRows = convertToNumberedIndex(barcode_present_rows);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...recordPresentRows,
        ...partNameEmptyRows,
        ...locationEmptyRows,
        ...availableQtyEmptyRows,
        ...partNoPresentRows,
        ...barcodePresentRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (partNameEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("part_name_empty_err"),
          };
        } else if (recordPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("part"),
            }),
          };
        } else if (partNoPresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("part_no"),
            }),
          };
        } else if (barcodePresentRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("entity_already_exists_err_msg", {
              entity: t("upc_barcode"),
            }),
          };
        } else if (locationEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("location_empty_err"),
          };
        } else if (availableQtyEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "warning",
            message: t("avail_qty_empty_err"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    if (screen === "partBatches") {
      const {
        part_not_found_rows,
        location_is_empty_rows,
        date_is_empty_rows,
        purchase_quantity_is_empty_rows,
        cost_is_empty_rows,
      } = res;

      const partNotFoundRows = convertToNumberedIndex(part_not_found_rows);
      const locationEmptyRows = convertToNumberedIndex(location_is_empty_rows);
      const dateEmptyRows = convertToNumberedIndex(date_is_empty_rows);
      const purchaseQtyEmptyRows = convertToNumberedIndex(
        purchase_quantity_is_empty_rows,
      );
      const costEmptyRows = convertToNumberedIndex(cost_is_empty_rows);

      const allIssuesSet = new Set([
        ...issueRowStringArr,
        ...partNotFoundRows,
        ...locationEmptyRows,
        ...dateEmptyRows,
        ...purchaseQtyEmptyRows,
        ...costEmptyRows,
      ]);

      const allIssuesSortedIndicesArr = [...allIssuesSet].sort((a, b) => a - b);

      issuesArrData = allIssuesSortedIndicesArr.map((rowIndex) => {
        if (partNotFoundRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("part_not_found_err"),
          };
        } else if (locationEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("location_empty_err"),
          };
        } else if (dateEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("purchase_date_empty_err"),
          };
        } else if (purchaseQtyEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("purchase_qty_empty_err"),
          };
        } else if (costEmptyRows.includes(rowIndex)) {
          return {
            rowIndex,
            type: "error",
            message: t("cost_empty_err"),
          };
        } else {
          return {
            rowIndex,
            type: "error",
            message: t("issue_at_row_no_err", { rowIndex }),
          };
        }
      });
    }

    console.log("importFile", importFile);
    console.log("issueRowStringArr", issueRowStringArr.length);

    setNoOfRowsInserted(importFile?.rows?.length - issueRowStringArr?.length);
    if (screen !== "users") {
      //This condition to wait for users to be added to firebase before setting these states
      //These states are set in users if block so don't need to be set here again
      setIssuesArr(issuesArrData);
      setReload(screen);
      setImportLoading(false);
      setMode(2);
    }
    //}
  };

  const handleImport = async () => {
    try {
      const colIndices = Object.keys(selectValues).map((index) => +index);
      const colOptions = Object.values(selectValues);
      const colOptionValues = colOptions.map((o) => o.value);

      //console.log(colIndices);
      //console.log(colOptions);

      // importFile?.columns?.forEach((col) => {
      //   if (colIndices.includes(col.colIndex)) {
      //     mappingData[colOptions[+col.colIndex].value] = +col.colIndex;
      //   } else {
      //     mappingData["skip"] = +col.colIndex;
      //   }
      // });
      let dbOptions = options.slice(1, options.length);
      let mappingData = {};

      dbOptions.forEach((option, i) => {
        if (colOptionValues.includes(option.value)) {
          let colOption = colOptions.find((o) => o.value === option.value);

          //Logic for inserting multiple indices for service/expense tasks
          if (colOption?.isMultiple) {
            let temp = "";
            colOptions
              .filter((option) => option?.isMultiple)
              .forEach((colOption) => {
                //console.log(colOption);
                if (colOption.checked) {
                  temp += `${colOption.index}:`;
                }
              });
            if (temp) {
              temp = temp.slice(0, temp.length - 1);
              mappingData[colOption.value] = temp;
            } else {
              mappingData[colOption.value] = 999;
            }
          } else {
            if (colOption.checked) {
              mappingData[option.value] = colOption.index;
            } else {
              mappingData[option.value] = 999;
            }
          }
        } else {
          mappingData[option.value] = 999;
        }
      });

      //console.log("mappingData", mappingData);

      //Check if atleast one of name(Vehicle Name), license_no or vin_no is selected
      const screensWithVehicles = [
        "dailymileage",
        "vehicles",
        "fillups",
        "service",
        "expense",
        "maintenancereminders",
        "renewals",
        "vehicleassignment",
        "equipment",
      ];
      if (screensWithVehicles.includes(screen)) {
        if (
          mappingData["name"] === 999 &&
          mappingData["license_no"] === 999 &&
          mappingData["vin_no"] === 999
        ) {
          let errMsg =
            screen === "vehicles"
              ? t("veh_license_or_vin_reqd_err_msg")
              : t("equipment_license_or_vin_reqd_err_msg");
          setErrMsg(errMsg);
          return;
        } else {
          setErrMsg("");
        }
      }

      //Mandatory fields check
      if (
        screen !== "maintenancereminders" &&
        screen !== "renewals" &&
        screen !== "vehicleassignment"
      ) {
        for (let option of otherMandatoryFields) {
          if (mappingData[option.value] === 999) {
            setErrMsg(
              t("import_mandatory_field_err_msg", { colName: option.label }),
            );
            return;
          } else {
            setErrMsg("");
          }
        }
      }

      //Custom mandatory fields check for maintenace reminders and renewals
      if (screen === "maintenancereminders" || screen === "renewals") {
        // if (screen === "maintenancereminders") {
        if (mappingData.service_task_name === 999) {
          setErrMsg(
            t("import_mandatory_field_err_msg", {
              colName:
                screen === "maintenancereminders"
                  ? t("service_task_name")
                  : t("expense_task_name"),
            }),
          );
          return;
        } else {
          setErrMsg("");
        }
        // }

        // if (screen === "renewals") {
        //   if (mappingData.expense_task_name === 999) {
        //     setErrMsg(
        //       t("import_mandatory_field_err_msg", {
        //         colName: t("expense_task_name"),
        //       })
        //     );
        //     return;
        //   } else {
        //     setErrMsg("");
        //   }
        // }

        if (mappingData.due_odo === 999 && mappingData.due_days === 999) {
          setErrMsg(t("odo_or_days_interval_reqd_err_msg"));
          return;
        } else {
          setErrMsg("");
        }
      }

      //Custom mandatory fields check for vehicle assignment
      if (screen === "vehicleassignment") {
        if (mappingData["user_name"] === 999 && mappingData["email"] === 999) {
          setErrMsg(t("user_name_or_email_reqd_err_msg"));
          return;
        } else {
          setErrMsg("");
        }
      }

      //Custom mandatory fields check for parts
      if (screen === "parts") {
        if (
          (mappingData["available_quantity"] === 999 &&
            mappingData["location"] !== 999) ||
          (mappingData["available_quantity"] !== 999 &&
            mappingData["location"] === 999)
        ) {
          const colName =
            mappingData["available_quantity"] === 999
              ? t("available_qty")
              : t("warehouse_loc");
          setErrMsg(
            t("import_mandatory_field_err_msg", {
              colName,
            }),
          );
          return;
        } else {
          setErrMsg("");
        }
      }

      //Custom mandatory fields check for part batches
      if (screen === "partBatches") {
        if (
          mappingData["part_name"] === 999 &&
          mappingData["part_number"] === 999
        ) {
          setErrMsg(t("part_name_or_part_number_reqd_err_msg"));
          return;
        } else {
          setErrMsg("");
        }

        if (
          mappingData["purchase_cost_per_unit"] === 999 &&
          mappingData["purchase_total_cost"] === 999
        ) {
          setErrMsg(t("cost_per_unit_or_total_cost_reqd_err_msg"));
          return;
        } else {
          setErrMsg("");
        }
      }

      //Check if all columns that are checked are also mapped. If not SetErrMsg'
      for (let option of colOptions) {
        if (option.checked && option.value === "skip") {
          setErrMsg(
            t("column_not_mapped_err_msg", { colName: option.colName }),
          );
          return;
        } else {
          setErrMsg("");
        }
      }

      // let dateFormatData = {};

      // for (let key of Object.keys(dateFormat)) {
      //   if (mappingData[key] === 999) {
      //     continue;
      //   }

      //   if (dateFormat[key]?.value) {
      //     setErrMsg("");
      //     dateFormatData[key] = dateFormat[key]?.value;
      //   } else {
      //     setErrMsg(t("date_format_mandatory_err_msg"));
      //     return;
      //   }

      //   // if (!dateFormat[key]?.value && mappingData[key] !== 999) {
      //   //   setErrMsg(
      //   //     "Date format is a mandatory field, please make sure it is selected."
      //   //   );
      //   //   return;
      //   // } else {
      //   //   setErrMsg("");
      //   //   dateFormatData[key] = dateFormat[key]?.value;
      //   // }
      // }
      const optionsWithDateFormat = colOptions.filter(
        (o) => o?.type === "date" && o?.checked,
      );
      const dateFormatEmpty = optionsWithDateFormat.some((o) => !o.dateFormat);
      if (dateFormatEmpty) {
        setErrMsg(t("date_format_mandatory_err_msg"));
        return;
      }
      let dateFormatData = {};
      if (optionsWithDateFormat.length > 0) {
        optionsWithDateFormat.forEach((o) => {
          dateFormatData[o.value] = o?.dateFormat?.value;
        });
      }

      setImportLoading(true);
      const fileName = `${Date.now()}.csv`;

      const s3UploadRes = await uploadCSVToS3(importFile?.file, fileName);
      if (s3UploadRes === 200) {
        const email = auth?.currentUser?.email;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let apiData = {
          action: "import_data",
          email: email,
          mapping_data: mappingData,
          date_format: dateFormatData,
          querystring: queryString,
          file_name: fileName,
          utc_offset: new Date().getTimezoneOffset(),
        };

        // if (screen === "vehicles" || screen === "equipment") {
        //   apiData.asset_type = screen === "vehicles" ? 0 : 1;
        // }
        if (screen === "maintenancereminders" || screen === "renewals") {
          apiData.type = screen === "maintenancereminders" ? 0 : 1;
        } else if (screen === "parts") {
          const createBatches =
            mappingData["available_quantity"] !== 999 &&
            mappingData["location"] !== 999;
          apiData.create_parts_batches = createBatches;
        }

        console.log("apiData", apiData);
        // Prepare the message to send
        let messageToSend = JSON.stringify(apiData);
        // if (screen === "maintenancereminders") {
        //   messageToSend = JSON.stringify({ ...apiData, type: 0 });
        // } else if (screen === "renewals") {
        //   messageToSend = JSON.stringify({ ...apiData, type: 1 });
        // } else if (screen === "parts") {
        //   const createBatches =
        //     mappingData["available_quantity"] !== 999 &&
        //     mappingData["location"] !== 999;
        //   messageToSend = JSON.stringify({
        //     ...apiData,
        //     create_parts_batches: createBatches,
        //   });
        // } else {
        //   console.log("api json", apiData);
        //   messageToSend = JSON.stringify(apiData);
        // }

        // Connect and send message using lazy WebSocket
        console.log("🔄 Connecting WebSocket for import request");

        // Store the message to send when connection opens
        pendingMessageRef.current = messageToSend;
        isIntentionalClosure.current = false;

        connect(); // lazy connect - message will be sent in onOpen callback
      }

      //socket.send(JSON.stringify(apiData));
    } catch (e) {
      console.log(e);
    }
  };

  const uploadCSVToS3 = async (file, fileName) => {
    try {
      const client = new S3Client({
        region: "us-east-2",
        credentials: fromCognitoIdentityPool({
          identityPoolId: IDENTITY_POOL_ID,
          client: new CognitoIdentityClient({ region: BUCKET_REGION }),
        }),
        apiVersion: "2006-03-01",
      });

      const command = new PutObjectCommand({
        Bucket: ALBUM_BUCKET_NAME,
        Key: `csv_data/org_${orgId}/${fileName}`,
        Body: file,
        ContentDisposition: "inline",
        ContentType: "text/csv",
        //ACL: "public-read",
      });
      const response = await client.send(command);
      //console.log("s3 response", response);
      const statusCode = response.$metadata.httpStatusCode;
      //console.log("statusCode in method", statusCode);
      return statusCode;
      //statusCodeArr.push(statusCode);
    } catch (err) {
      console.error("s3 error", err);
      return err;
    }
  };

  return (
    <>
      {showErrDetails && (
        <ErrorDetailsTable
          showPopup={showErrDetails}
          setShowPopup={setShowErrDetails}
          issuesArr={issuesArr}
          importFile={importFile}
          selectValues={selectValues}
        />
      )}
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={subscribeMsg}
          onGoToBilling={() => setShowPopup(false)}
        />
      )}
      <Modal show={showPopup} size={"lg"} style={{ zIndex: 999 }}>
        <Modal.Header>
          <div>
            <h5>
              {/* {mode === 1
              ? "Match the CSV’s file’s columns to Simply Fleet fields"
              : modalHeading} */}
              {modalHeading}
            </h5>
            {(screenName === "service" || screen === "service") && (
              <Desc>
                <Desc>{t("only_vehicles_for_service_import_msg")}</Desc>
              </Desc>
            )}
          </div>

          <div
            className="d-flex justify-content-end"
            //style={{ width: "-webkit-fill-available" }}
          >
            <ActionIconContainer onClick={handleClose}>
              <i className="fi fi-rr-cross-small" />
            </ActionIconContainer>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            height: !screenName
              ? window.innerHeight - 200
              : window.innerHeight - 232,
          }}
        >
          {!screenName && (
            <div className="d-flex gap-1 align-items-center mb-3">
              <span>{t("import_data_for")} :</span>
              <Select
                id="module-select"
                options={moduleOptions}
                value={selectModule}
                onChange={(option) => {
                  if (tag === "free-user") {
                    setSubscribeMsg(t("subscribe_msg"));
                    setShowSubscribePopup(true);
                    return;
                  }
                  if (tag === "essential-user" && option?.value === "parts") {
                    setSubscribeMsg(t("subscribe_to_advanced_msg"));
                    setShowSubscribePopup(true);
                    return;
                  }
                  setSelectModule(option);
                  setScreen(option?.value);
                }}
                //onCreateOption={handleCreate}
                placeholder={t("select_module")}
                styles={{
                  ...formStyles,

                  container: (baseStyles, state) => ({
                    ...baseStyles,
                    minHeight: "34px",
                    width: "220px",
                  }),
                }}
                isDisabled={mode === 1 || mode === 2}
              />
            </div>
          )}
          {screen && <Steps model={stepItems} activeIndex={mode} />}
          {importLoading ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                // height: screenName
                //   ? window.innerHeight - 335
                //   : window.innerHeight - 285,
                height: window.innerHeight - 315,
              }}
            >
              <TableSpinner animation="border" />
              <span>{t("import_in_prog")}</span>
            </div>
          ) : (
            <>
              {screen && (
                <ScrollableBody isErr={errMsg} height={scrollableBodyHeight}>
                  {mode === 0 && (
                    <ImportFileUploader
                      importFile={importFile}
                      setImportFile={setImportFile}
                      mode={mode}
                      setMode={setMode}
                      selectValues={selectValues}
                      setSelectValues={setSelectValues}
                      errMsg={errMsg}
                      setErrMsg={setErrMsg}
                      sampleFileName={sampleFileName}
                    />
                  )}

                  {mode === 1 && (
                    <ImportColMappingComponent
                      importFile={importFile}
                      setImportFile={setImportFile}
                      errMsg={errMsg}
                      setErrMsg={setErrMsg}
                      selectValues={selectValues}
                      setSelectValues={setSelectValues}
                      //dateFormat={dateFormat}
                      // setDateFormat={setDateFormat}
                      screenName={screen}
                      setVehicleLimitErrMsg={setVehicleLimitErrMsg}
                      setDisableImport={setDisableImport}
                    />
                  )}

                  {mode === 2 && (
                    <ImportCompleteComponent
                      issuesArr={issuesArr}
                      importFile={importFile}
                      selectValues={selectValues}
                      showErrDetails={showErrDetails}
                      setShowErrDetails={setShowErrDetails}
                      noOfRowsInserted={noOfRowsInserted}
                    />
                  )}
                </ScrollableBody>
              )}
            </>
          )}
          {errMsg && (
            <div className="pt-1">
              <Error error={errMsg} />
            </div>
          )}
        </Modal.Body>
        {/* {mode === 0 && (
            <div className="d-flex justify-content-start">
              <AddFormButton
                type="button"
                onClick={handleNext}
                disabled={!importFile}
              >
                Next
                </AddFormButton>
                </div>
              )} */}
        {mode === 1 && (
          <Modal.Footer>
            <div
              className="d-flex justify-content-between"
              style={{ width: "-webkit-fill-available" }}
            >
              <FilterButton
                type="button"
                id="import-back-btn"
                onClick={handleBack}
                disabled={importLoading}
              >
                {t("back")}
              </FilterButton>
              {vehicleLimitErrMsg && (
                <div className="mx-3">
                  <Error error={vehicleLimitErrMsg} />
                </div>
              )}
              <AddFormButton
                type="button"
                id="import-btn"
                onClick={handleImport}
                disabled={importLoading || disableImport}
              >
                {t("import")}
              </AddFormButton>
            </div>
          </Modal.Footer>
        )}
        {mode === 2 && (
          <Modal.Footer>
            <AddFormButton
              type="button"
              id="ok-btn"
              onClick={handleOkay}
              //disabled={disableImport || importLoading}
            >
              {t("ok")}
            </AddFormButton>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default ImportComponent;

//styles
const ScrollableBody = styled.div`
  height: ${(p) => p.height}px;
  overflow: auto;
  ${scrollbarStyles}
  margin-top: 1rem;
`;
